import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { useId } from 'react';
import { cn } from '../../lib/utils';
const Textarea = React.forwardRef(({ className, label, ...props }, ref) => {
    const uuid = useId();
    return (_jsxs("div", { className: "flex w-full flex-col gap-2", children: [label && (_jsx("label", { className: "text-gray-light-700 text-sm font-medium", htmlFor: uuid, children: label })), _jsx("textarea", { className: cn('border-input placeholder:text-muted-foreground focus-visible:ring-ring flex min-h-[60px] w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-sm focus-visible:ring-1 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm', className), id: uuid, ref: ref, ...props })] }));
});
Textarea.displayName = 'Textarea';
export { Textarea };
